import {
  WorkPolicyApplicationAction,
  WorkPolicyApplicationDraft,
  WorkPolicyApplicationPolicySelection
} from "./work-policy-application.types";

function createDraftForPolicy(
  state: WorkPolicyApplicationDraft,
  policy: WorkPolicyApplicationPolicySelection
): WorkPolicyApplicationDraft {
  const common = {
    workPolicyId: policy.workPolicyId,
    startDate: state.startDate,
    endDate: state.endDate,
    policySnapshot: policy.snapshot
  };

  if (policy.workType === "staggered") {
    return {
      ...common,
      workType: "staggered",
      allowedStartTimes: [],
      selectedStartTime: null
    };
  }
  if (policy.workType === "selective") {
    return {
      ...common,
      workType: "selective",
      settlementStatus: "loading",
      settlementPeriods: []
    };
  }
  return {
    ...common,
    workType: "flexible",
    flexibleMode: policy.flexibleMode,
    schedule: []
  };
}

export function requiresWorkPolicySelectionConfirmation(
  state: WorkPolicyApplicationDraft,
  policy: {
    workPolicyId: number;
    workType: "staggered" | "flexible" | "selective";
    flexibleMode?: "DAILY_DATE" | "WEEKLY_PATTERN" | null;
  }
): boolean {
  return (
    state.workPolicyId !== policy.workPolicyId ||
    state.workType !== policy.workType ||
    (state.workType === "flexible" &&
      policy.workType === "flexible" &&
      state.flexibleMode !== policy.flexibleMode)
  );
}

export function workPolicyApplicationReducer(
  state: WorkPolicyApplicationDraft,
  action: WorkPolicyApplicationAction
): WorkPolicyApplicationDraft {
  const { policy } = action;
  const samePolicy =
    state.workPolicyId === policy.workPolicyId &&
    state.workType === policy.workType &&
    (state.workType !== "flexible" ||
      state.flexibleMode === policy.flexibleMode);

  return samePolicy
    ? { ...state, policySnapshot: policy.snapshot }
    : createDraftForPolicy(state, policy);
}
